import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { RTO_PACKAGE_ACTIONS_DIALOG } from "@/constants/dialog-constants";
import { NavigationRoutes } from "@/components/navigation/constants";
import { closeDialog } from "@/store/reducers/dialogReducer";
import { RootState } from "@/store/store";
import { withRtoQuery, canAccessRtoBulkPickup } from "@/utils/return-rto";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const RtoPackageActionsDialog: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isOpen, dialogType } = useSelector(
    (state: RootState) => state.dialog
  );
  const roles = useSelector((state: RootState) => state.authentication.roles);
  const canUseBulkPickup = canAccessRtoBulkPickup(roles);
  const isOpened = isOpen && dialogType === RTO_PACKAGE_ACTIONS_DIALOG;

  const handleClose = () => {
    dispatch(closeDialog());
  };

  const handleNavigate = (route: NavigationRoutes) => {
    handleClose();
    navigate(route);
  };

  const handleBulkPickupNavigate = () => {
    handleClose();
    navigate(withRtoQuery(NavigationRoutes.BULK_PICK_UP_VALIDATION));
  };

  return (
    <Dialog open={isOpened} onOpenChange={(open) => !open && handleClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Actions</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-2 pt-2">
          {canUseBulkPickup && (
            <Button
              variant="outline"
              className="w-full"
              onClick={handleBulkPickupNavigate}
            >
              Scan en masse (RTO)
            </Button>
          )}
          <Button
            variant="outline"
            className="w-full"
            onClick={() => handleNavigate(NavigationRoutes.RTO_PACKAGE)}
          >
            Suivi colis RTO
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default RtoPackageActionsDialog;
